import type { DateTime } from "luxon";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { useSnackbar } from "../../../../contexts/SnackbarContext";
import { backendService } from "../../../../services/backend.service";

export function useApplyPrimaryJob(nurseId: number | undefined) {
	const { t } = useTranslation();
	const { chosenDepartment, refreshDepartmentData } = useHospitalData();
	const { showSnackbar } = useSnackbar();

	const anchorRef = useRef<HTMLButtonElement | null>(null);
	const [pickerOpen, setPickerOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [selectedDate, setSelectedDate] = useState<DateTime | null>(null);

	const handleDateChange = (date: DateTime | null) => {
		setSelectedDate(date);
		setPickerOpen(false);
	};

	const handleSave = async () => {
		const isoDate = selectedDate?.toISODate();
		if (!isoDate || !nurseId) return;
		setLoading(true);
		try {
			await backendService.applyPrimaryJobToShifts(chosenDepartment.department_id, nurseId, isoDate);
			await refreshDepartmentData(chosenDepartment.department_id, false);
			showSnackbar(t("apply.primary.job.success"), "success");
			setSelectedDate(null);
		} catch {
			showSnackbar(t("error.general"), "error");
		} finally {
			setLoading(false);
		}
	};

	return {
		anchorRef,
		pickerOpen,
		setPickerOpen,
		loading,
		selectedDate,
		handleDateChange,
		handleSave,
	};
}
